import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon } from 'assets';

import styles from './PaymentCompleteDialog.module.scss';

export interface PaymentCompleteDialogProps extends DialogProps {
  onConfirm: () => void;
}

export function PaymentCompleteDialog({ onConfirm, ...rest }: PaymentCompleteDialogProps) {
  const { t } = useTranslation('providerRoom');

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <CheckCircleIcon className={styles.icon} color='primary' />

        <Typography component='p' variant='body4'>
          {t('paymentCompleteDialog.title')}
        </Typography>

        <Button variant='contained' onClick={onConfirm} className={styles.formButton}>
          {t('done')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
